<template>
  <main class="sessoesPainel">
    <header class="sessoesCabecalho">
      <div>
        <p class="sessoesEyebrow">Monitoramento operacional</p>
        <h1>Sessões</h1>
        <p class="sessoesAtualizacao">
          <span
            class="sessoesStatus"
            :class="{ sessoesStatusErro: erroResumo }"
          ></span>
          {{
            atualizadoEm
              ? "Atualizado às " + formatarHora(atualizadoEm)
              : "Aguardando atualização"
          }}
        </p>
      </div>

      <div class="sessoesCabecalhoAcoes">
        <label
          v-if="exibeFiltroSite"
          class="sessoesFiltroSite"
        >
          <span>Site</span>
          <Combo
            :itens="$global.sites_filtro_completo()"
            v-model="filtroSite"
            @input="carregarResumo"
          />
        </label>
        <button
          type="button"
          class="sessoesAtualizar"
          :disabled="carregandoResumo"
          title="Atualizar"
          aria-label="Atualizar dados das sessões"
          @click="carregarResumo"
        >
          <i
            class="fa fa-refresh"
            :class="{ faSpin: carregandoResumo }"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    </header>

    <div v-if="erroResumo" class="sessoesAlerta">
      <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
      {{ erroResumo }}
    </div>

    <section class="sessoesMetricas" aria-label="Resumo das sessões ativas">
      <article class="sessoesMetrica">
        <span class="sessoesMetricaIcone sessoesMetricaIconeVerde">
          <i class="fa fa-play-circle" aria-hidden="true"></i>
        </span>
        <div>
          <span>Sessões ativas</span>
          <strong>{{ formatarNumero(dashboard.totais.sessoes) }}</strong>
        </div>
      </article>
      <article class="sessoesMetrica">
        <span class="sessoesMetricaIcone sessoesMetricaIconeAzul">
          <i class="fa fa-users" aria-hidden="true"></i>
        </span>
        <div>
          <span>Usuários conectados</span>
          <strong>{{ formatarNumero(dashboard.totais.usuarios) }}</strong>
        </div>
      </article>
      <article class="sessoesMetrica">
        <span class="sessoesMetricaIcone sessoesMetricaIconeAmarelo">
          <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
        </span>
        <div>
          <span>Eventos com audiência</span>
          <strong>{{ formatarNumero(dashboard.totais.eventos) }}</strong>
        </div>
      </article>
      <article class="sessoesMetrica">
        <span class="sessoesMetricaIcone sessoesMetricaIconeCinza">
          <i class="fa fa-server" aria-hidden="true"></i>
        </span>
        <div>
          <span>Servidores em uso</span>
          <strong>{{ formatarNumero(dashboard.totais.servidores) }}</strong>
        </div>
      </article>
      <article class="sessoesMetrica">
        <span class="sessoesMetricaIcone sessoesMetricaIconeVioleta">
          <i class="fa fa-random" aria-hidden="true"></i>
        </span>
        <div>
          <span>Canais ativos</span>
          <strong>{{ formatarNumero(dashboard.totais.canais) }}</strong>
        </div>
      </article>
    </section>

    <nav class="sessoesAbas" aria-label="Visualizações de sessões">
      <button
        type="button"
        :class="{ ativo: abaSelecionada == 'resumo' }"
        :aria-selected="abaSelecionada == 'resumo' ? 'true' : 'false'"
        @click="trocarAba('resumo')"
      >
        <i class="fa fa-dashboard" aria-hidden="true"></i>
        Visão geral
      </button>
      <button
        type="button"
        :class="{ ativo: abaSelecionada == 'estatisticas' }"
        :aria-selected="abaSelecionada == 'estatisticas' ? 'true' : 'false'"
        @click="trocarAba('estatisticas')"
      >
        <i class="fa fa-bar-chart" aria-hidden="true"></i>
        Estatísticas
      </button>
      <button
        v-if="
          podeVerDistribuicao &&
          retornaSite() !== 'Stream1x2' &&
          retornaSite() !== '7live'
        "
        type="button"
        :class="{ ativo: abaSelecionada == 'resumo-evento' }"
        :aria-selected="
          abaSelecionada == 'resumo-evento' ? 'true' : 'false'
        "
        @click="trocarAba('resumo-evento')"
      >
        <i class="fa fa-calendar" aria-hidden="true"></i>
        Eventos
      </button>
      <button
        v-if="podeVerDistribuicao && retornaSite() !== 'Stream1x2'"
        type="button"
        :class="{ ativo: abaSelecionada == 'resumo-servidor' }"
        :aria-selected="
          abaSelecionada == 'resumo-servidor' ? 'true' : 'false'
        "
        @click="trocarAba('resumo-servidor')"
      >
        <i class="fa fa-server" aria-hidden="true"></i>
        Servidores
      </button>
      <button
        type="button"
        :class="{ ativo: abaSelecionada == 'detalhado' }"
        :aria-selected="abaSelecionada == 'detalhado' ? 'true' : 'false'"
        @click="trocarAba('detalhado')"
      >
        <i class="fa fa-user" aria-hidden="true"></i>
        Usuários
      </button>
      <button
        type="button"
        :class="{ ativo: abaSelecionada == 'login' }"
        :aria-selected="abaSelecionada == 'login' ? 'true' : 'false'"
        @click="trocarAba('login')"
      >
        <i class="fa fa-sign-in" aria-hidden="true"></i>
        Logins
      </button>
      <button
        v-if="retornaSite() !== 'Stream1x2'"
        type="button"
        :class="{ ativo: abaSelecionada == 'historico' }"
        :aria-selected="abaSelecionada == 'historico' ? 'true' : 'false'"
        @click="trocarAba('historico')"
      >
        <i class="fa fa-history" aria-hidden="true"></i>
        Histórico
      </button>
      <button
        type="button"
        :class="{ ativo: abaSelecionada == 'historico-detalhado' }"
        :aria-selected="
          abaSelecionada == 'historico-detalhado' ? 'true' : 'false'
        "
        @click="trocarAba('historico-detalhado')"
      >
        <i class="fa fa-line-chart" aria-hidden="true"></i>
        Histórico Geral
      </button>
    </nav>

    <section v-show="abaSelecionada == 'resumo'" class="sessoesVisaoGeral">
      <article class="sessoesWidget">
        <div class="sessoesWidgetCabecalho">
          <div>
            <span>Audiência agora</span>
            <h2>Eventos com mais sessões</h2>
          </div>
          <strong>{{ dashboard.eventos.length }}</strong>
        </div>

        <div v-if="dashboard.eventos.length" class="sessoesRanking">
          <button
            v-for="evento in dashboard.eventos.slice(0, 8)"
            :key="evento._id"
            type="button"
            class="sessoesRankingItem"
            @click="clicouEvento(evento._id)"
          >
            <span class="sessoesRankingTexto">
              <strong>{{ evento.nome }}</strong>
              <small>
                {{ evento.site || "Sem site" }} ·
                {{ formatarNumero(evento.usuarios) }} usuários
              </small>
            </span>
            <span class="sessoesRankingBarra">
              <span
                :style="{
                  width:
                    percentual(
                      evento.sessoes,
                      dashboard.eventos[0].sessoes
                    ) + '%',
                }"
              ></span>
            </span>
            <strong class="sessoesRankingValor">
              {{ formatarNumero(evento.sessoes) }}
            </strong>
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </button>
        </div>
        <div v-else class="sessoesVazio">
          <i class="fa fa-calendar-o" aria-hidden="true"></i>
          <span>Nenhum evento com sessões ativas</span>
        </div>
      </article>

      <article class="sessoesWidget">
        <div class="sessoesWidgetCabecalho">
          <div>
            <span>Infraestrutura</span>
            <h2>Distribuição por servidor</h2>
          </div>
          <strong>{{ dashboard.servidores.length }}</strong>
        </div>

        <div v-if="dashboard.servidores.length" class="sessoesServidores">
          <div
            v-for="servidor in dashboard.servidores.slice(0, 8)"
            :key="servidor._id"
            class="sessoesServidorItem"
          >
            <div class="sessoesServidorLinha">
              <span class="sessoesServidorNome">
                <i class="fa fa-server" aria-hidden="true"></i>
                <span>
                  <strong>{{ nomeServidor(servidor) }}</strong>
                  <small>
                    {{ formatarNumero(servidor.eventos) }} eventos ·
                    {{ formatarNumero(servidor.canais) }} canais
                  </small>
                </span>
              </span>
              <strong>{{ formatarNumero(servidor.sessoes) }}</strong>
            </div>
            <span class="sessoesServidorBarra">
              <span
                :style="{
                  width:
                    percentual(
                      servidor.sessoes,
                      dashboard.servidores[0].sessoes
                    ) + '%',
                }"
              ></span>
            </span>
          </div>
        </div>
        <div v-else class="sessoesVazio">
          <i class="fa fa-server" aria-hidden="true"></i>
          <span>Nenhum servidor em uso</span>
        </div>

        <footer class="sessoesWidgetRodape">
          <span>Sessões por usuário</span>
          <strong>{{ mediaSessoesUsuario }}</strong>
        </footer>
      </article>
    </section>

    <section
      v-if="abaSelecionada != 'resumo'"
      class="sessoesPainelConteudo"
    >
      <div
        v-if="
          abaSelecionada == 'resumo-evento' &&
          podeVerDistribuicao &&
          retornaSite() !== 'Stream1x2' &&
          retornaSite() !== '7live'
        "
      >
        <ListSessaoViewResumoServidor
          key="resumo-evento"
          ref="resumoEvento"
          propView="evento"
          @clicouEvento="clicouEvento"
        />
      </div>
      <div v-if="abaSelecionada == 'estatisticas'">
        <ListSessaoViewEstatisticas
          ref="listSessaoViewEstatisticas"
          :site="filtroSite"
        />
      </div>
      <div
        v-if="
          abaSelecionada == 'resumo-servidor' && podeVerDistribuicao
        "
      >
        <ListSessaoViewResumoServidor
          key="resumo-servidor"
          ref="resumoServidor"
          propView="servidor"
        />
      </div>
      <div v-if="abaSelecionada == 'detalhado'">
        <ListSessaoView ref="listSessaoView" />
      </div>
      <div v-if="abaSelecionada == 'login'">
        <ListSessaoLogin ref="listSessaoLogin" />
      </div>
      <div v-if="abaSelecionada == 'historico-detalhado'">
        <ListSessaoViewHistoricoDetalhado
          ref="listSessaoViewHistoricoDetalhado"
          :site="filtroSite"
        />
      </div>
      <div v-if="abaSelecionada == 'historico'">
        <ListSessaoViewHistorico ref="listSessaoViewHistorico" />
      </div>
    </section>
  </main>
</template>

<script>
import { api } from "@/services/api.js";
import Combo from "../components/Combo.vue";
import ListSessaoView from "../lists/ListSessaoView";
import ListSessaoViewEstatisticas from "../lists/ListSessaoViewEstatisticas";
import ListSessaoViewHistoricoDetalhado from "../lists/ListSessaoViewHistoricoDetalhado";
import ListSessaoViewResumoServidor from "../lists/ListSessaoViewResumoServidor";
import ListSessaoLogin from "../lists/ListSessaoLogin";
import ListSessaoViewHistorico from "../lists/ListSessaoViewHistorico";

function dashboardVazio() {
  return {
    totais: {
      sessoes: 0,
      usuarios: 0,
      eventos: 0,
      servidores: 0,
      canais: 0,
    },
    eventos: [],
    servidores: [],
  };
}

export default {
  name: "SessaoView",
  components: {
    Combo,
    ListSessaoView,
    ListSessaoViewEstatisticas,
    ListSessaoViewHistoricoDetalhado,
    ListSessaoViewResumoServidor,
    ListSessaoLogin,
    ListSessaoViewHistorico,
  },
  computed: {
    tipoUsuario() {
      return this.$sessao && this.$sessao.usuario
        ? this.$sessao.usuario.tipoUsuario
        : "";
    },
    podeVerDistribuicao() {
      return (
        this.tipoUsuario == "Administrador" ||
        (this.tipoUsuario == "Apresentador" && this.$site == "Weddbets")
      );
    },
    exibeFiltroSite() {
      return (
        this.tipoUsuario == "Administrador" &&
        this.retornaSite() !== "Share" &&
        this.retornaSite() !== "Stream1x2" &&
        this.retornaSite() !== "7live"
      );
    },
    mediaSessoesUsuario() {
      if (!this.dashboard.totais.usuarios) {
        return "0,0";
      }

      return (
        this.dashboard.totais.sessoes / this.dashboard.totais.usuarios
      ).toLocaleString("pt-BR", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    async carregarResumo() {
      if (this.carregandoResumo) {
        return;
      }

      this.carregandoResumo = true;
      this.erroResumo = "";

      try {
        var filtros =
          this.filtroSite !== "Todos"
            ? "?site=" + encodeURIComponent(this.filtroSite)
            : "";
        var response = await api.get("/sessaoView/dashboard" + filtros);

        api.valid(response.data, this.$router);

        if (response.data.erro) {
          throw new Error(
            response.data.mensagem || "Não foi possível carregar as sessões."
          );
        }

        this.dashboard = {
          totais: Object.assign(
            dashboardVazio().totais,
            response.data.totais || {}
          ),
          eventos: response.data.eventos || [],
          servidores: response.data.servidores || [],
        };
        this.atualizadoEm = response.data.atualizadoEm || new Date();

        if (
          this.abaSelecionada == "estatisticas" &&
          this.$refs.listSessaoViewEstatisticas
        ) {
          this.$refs.listSessaoViewEstatisticas.carregarItens();
        }
      } catch (erro) {
        this.erroResumo =
          erro && erro.message
            ? erro.message
            : "Não foi possível carregar as sessões.";
      } finally {
        this.carregandoResumo = false;
      }
    },
    trocarAba(aba) {
      this.abaSelecionada = aba;
    },
    clicouEvento(id) {
      this.abaSelecionada = "detalhado";
      this.$nextTick(() => {
        var lista = this.$refs.listSessaoView;

        if (lista) {
          lista.selecionarEvento(id);
        }
      });
    },
    formatarNumero(valor) {
      return Number(valor || 0).toLocaleString("pt-BR");
    },
    formatarHora(data) {
      return new Intl.DateTimeFormat("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }).format(new Date(data));
    },
    percentual(valor, total) {
      if (!total) {
        return 0;
      }

      return Math.max(4, Math.min(100, (Number(valor) / Number(total)) * 100));
    },
    nomeServidor(item) {
      var servidores = this.$global.servidores_sip();
      var servidor = servidores[item.servidorTipo + "_" + item.servidor];

      return servidor && servidor.nome
        ? servidor.nome
        : item.servidor || "Servidor não identificado";
    },
  },
  data: function () {
    return {
      abaSelecionada: "resumo",
      atualizadoEm: null,
      carregandoResumo: false,
      dashboard: dashboardVazio(),
      erroResumo: "",
      filtroSite: "Todos",
      timerAtualizacao: null,
    };
  },
  mounted() {
    this.carregarResumo();
    this.timerAtualizacao = setInterval(this.carregarResumo, 30000);
  },
  beforeDestroy() {
    clearInterval(this.timerAtualizacao);
  },
};
</script>

<style>
.sessoesPainel {
  color: #262b30;
  margin: 0 auto;
  max-width: 1500px;
  padding: 4px 20px 28px;
  text-align: left;
}

.sessoesCabecalho {
  align-items: flex-end;
  border-bottom: 1px solid #dfe3e7;
  display: flex;
  justify-content: space-between;
  padding: 4px 0 16px;
}

.sessoesEyebrow {
  color: #398063;
  font-size: 10px;
  font-weight: 700;
  margin: 0 0 3px;
  text-transform: uppercase;
}

.sessoesCabecalho h1 {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
}

.sessoesAtualizacao {
  align-items: center;
  color: #727b84;
  display: flex;
  font-size: 11px;
  gap: 6px;
  margin: 5px 0 0;
}

.sessoesStatus {
  background: #35a66f;
  border-radius: 50%;
  height: 7px;
  width: 7px;
}

.sessoesStatusErro {
  background: #cf4d4d;
}

.sessoesCabecalhoAcoes {
  align-items: flex-end;
  display: flex;
  gap: 8px;
}

.sessoesFiltroSite {
  margin: 0;
  width: 180px;
}

.sessoesFiltroSite > span {
  color: #65707a;
  display: block;
  font-size: 10px;
  font-weight: 700;
  margin-bottom: 4px;
}

.sessoesFiltroSite .form-control {
  border-radius: 3px;
  font-size: 12px;
  height: 34px;
}

.sessoesAtualizar {
  align-items: center;
  background: #ffffff;
  border: 1px solid #b8c0c7;
  border-radius: 3px;
  color: #3f4952;
  display: inline-flex;
  height: 34px;
  justify-content: center;
  width: 36px;
}

.sessoesAtualizar:hover {
  background: #f1f3f5;
  color: #1e252b;
}

.sessoesAtualizar:disabled {
  cursor: wait;
  opacity: 0.65;
}

.faSpin {
  animation: sessoesGirar 0.9s linear infinite;
}

@keyframes sessoesGirar {
  to {
    transform: rotate(360deg);
  }
}

.sessoesAlerta {
  align-items: center;
  background: #fff5f5;
  border: 1px solid #f2c4c4;
  color: #a33b3b;
  display: flex;
  font-size: 12px;
  gap: 8px;
  margin-top: 12px;
  padding: 9px 12px;
}

.sessoesMetricas {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  margin: 14px 0 16px;
}

.sessoesMetrica {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dfe3e7;
  border-radius: 4px;
  display: flex;
  gap: 11px;
  min-height: 72px;
  padding: 11px 13px;
}

.sessoesMetricaIcone {
  align-items: center;
  border-radius: 3px;
  display: inline-flex;
  flex: 0 0 36px;
  height: 36px;
  justify-content: center;
}

.sessoesMetricaIconeVerde {
  background: #e4f4eb;
  color: #27805a;
}

.sessoesMetricaIconeAzul {
  background: #e7f0f7;
  color: #386f97;
}

.sessoesMetricaIconeAmarelo {
  background: #fff4d8;
  color: #9b7417;
}

.sessoesMetricaIconeCinza {
  background: #eceff1;
  color: #525d66;
}

.sessoesMetricaIconeVioleta {
  background: #eee9f5;
  color: #70568f;
}

.sessoesMetrica div {
  min-width: 0;
}

.sessoesMetrica div span {
  color: #6f7881;
  display: block;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.25;
}

.sessoesMetrica div strong {
  display: block;
  font-size: 21px;
  font-weight: 600;
  line-height: 1.15;
  margin-top: 3px;
}

.sessoesAbas {
  border-bottom: 1px solid #ccd2d7;
  display: flex;
  gap: 2px;
  overflow-x: auto;
}

.sessoesAbas button {
  align-items: center;
  background: transparent;
  border: 0;
  border-bottom: 3px solid transparent;
  color: #66717a;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 11px;
  font-weight: 600;
  gap: 6px;
  height: 38px;
  padding: 0 13px;
}

.sessoesAbas button:hover {
  background: #f3f5f6;
  color: #252b30;
}

.sessoesAbas button.ativo {
  border-bottom-color: #35a66f;
  color: #22282d;
}

.sessoesVisaoGeral {
  display: grid;
  gap: 14px;
  grid-template-columns: minmax(0, 1.35fr) minmax(360px, 0.85fr);
  padding-top: 14px;
}

.sessoesWidget {
  background: #ffffff;
  border: 1px solid #dfe3e7;
  border-radius: 4px;
  min-width: 0;
}

.sessoesWidgetCabecalho {
  align-items: flex-start;
  border-bottom: 1px solid #e6e9ec;
  display: flex;
  justify-content: space-between;
  padding: 13px 15px 11px;
}

.sessoesWidgetCabecalho span {
  color: #398063;
  display: block;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
}

.sessoesWidgetCabecalho h2 {
  font-size: 13px;
  font-weight: 600;
  margin: 2px 0 0;
}

.sessoesWidgetCabecalho > strong {
  background: #edf0f2;
  border-radius: 3px;
  color: #4f5962;
  font-size: 11px;
  min-width: 28px;
  padding: 3px 7px;
  text-align: center;
}

.sessoesRanking {
  padding: 4px 0;
}

.sessoesRankingItem {
  align-items: center;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #edf0f2;
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(180px, 1.4fr) minmax(90px, 1fr) 46px 10px;
  min-height: 57px;
  padding: 8px 15px;
  text-align: left;
  width: 100%;
}

.sessoesRankingItem:last-child {
  border-bottom: 0;
}

.sessoesRankingItem:hover {
  background: #f7f9f8;
}

.sessoesRankingTexto {
  min-width: 0;
}

.sessoesRankingTexto strong,
.sessoesRankingTexto small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sessoesRankingTexto strong {
  color: #2c3338;
  font-size: 12px;
}

.sessoesRankingTexto small {
  color: #7a838b;
  font-size: 9px;
  margin-top: 3px;
}

.sessoesRankingBarra,
.sessoesServidorBarra {
  background: #e7ebed;
  border-radius: 2px;
  display: block;
  height: 5px;
  overflow: hidden;
}

.sessoesRankingBarra span {
  background: #3b8e69;
  display: block;
  height: 100%;
}

.sessoesRankingValor {
  color: #31383d;
  font-size: 13px;
  text-align: right;
}

.sessoesRankingItem > i {
  color: #899198;
}

.sessoesServidores {
  padding: 5px 15px 8px;
}

.sessoesServidorItem {
  border-bottom: 1px solid #edf0f2;
  padding: 10px 0;
}

.sessoesServidorItem:last-child {
  border-bottom: 0;
}

.sessoesServidorLinha {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 7px;
}

.sessoesServidorLinha > strong {
  font-size: 12px;
}

.sessoesServidorNome {
  align-items: center;
  display: flex;
  gap: 9px;
  min-width: 0;
}

.sessoesServidorNome > i {
  color: #6d7780;
}

.sessoesServidorNome span {
  min-width: 0;
}

.sessoesServidorNome strong,
.sessoesServidorNome small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sessoesServidorNome strong {
  font-size: 11px;
}

.sessoesServidorNome small {
  color: #808890;
  font-size: 9px;
  margin-top: 2px;
}

.sessoesServidorBarra span {
  background: #63717c;
  display: block;
  height: 100%;
}

.sessoesWidgetRodape {
  align-items: center;
  background: #f6f7f8;
  border-top: 1px solid #e1e5e8;
  display: flex;
  font-size: 10px;
  justify-content: space-between;
  padding: 9px 15px;
}

.sessoesWidgetRodape span {
  color: #707a83;
}

.sessoesWidgetRodape strong {
  font-size: 12px;
}

.sessoesVazio {
  align-items: center;
  color: #818a91;
  display: flex;
  flex-direction: column;
  font-size: 11px;
  gap: 8px;
  justify-content: center;
  min-height: 190px;
}

.sessoesVazio i {
  font-size: 20px;
}

.sessoesPainelConteudo {
  padding-top: 14px;
}

.sessoesSubaba {
  margin: 0;
}

.sessoesSubabaCorpo {
  background: #ffffff;
  border: 1px solid #dfe3e7;
  border-radius: 4px;
  max-width: 100%;
  overflow: hidden;
  padding: 0;
}

.sessoesSubabaCabecalho {
  align-items: flex-start;
  border-bottom: 1px solid #e3e7ea;
  display: flex;
  justify-content: space-between;
  padding: 13px 16px 11px;
  text-align: left;
}

.sessoesSubabaCabecalho span {
  color: #398063;
  display: block;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
}

.sessoesSubabaCabecalho h2 {
  color: #2d3439;
  font-size: 13px;
  font-weight: 600;
  margin: 2px 0 0;
}

.sessoesSubabaCabecalho > strong {
  background: #edf0f2;
  border-radius: 3px;
  color: #4f5962;
  font-size: 11px;
  min-width: 28px;
  padding: 3px 7px;
  text-align: center;
}

.sessoesPainelConteudo .sessoesSubabaFiltros {
  background: #f7f8f9;
  border: 0;
  border-bottom: 1px solid #e1e5e8;
  border-radius: 0;
  min-height: 56px;
  padding: 10px 16px;
}

.sessoesPainelConteudo .sessoesSubabaFiltrosData {
  justify-content: center !important;
}

.sessoesSubabaFiltros .form-control {
  background: #ffffff;
  border-color: #cfd5d9;
  border-radius: 3px;
}

.sessoesSubabaFiltros .btn {
  align-items: center;
  border-radius: 3px;
  display: inline-flex;
  font-size: 10px;
  font-weight: 600;
  justify-content: center;
  padding-left: 12px;
  padding-right: 12px;
}

.sessoesSubabaFiltros + hr,
.sessoesSubabaCabecalho ~ hr {
  display: none;
}

.sessoesPainelConteudo .sessoesSubabaTabela {
  border: 0;
  border-radius: 0;
  margin: 0;
}

.sessoesPainelConteudo .sessoesSubabaTabela .list-group-item-dark {
  background: #f1f3f5;
  border-bottom: 1px solid #dce1e4;
  color: #69737b;
  padding: 8px 16px;
}

.sessoesSubabaTabela .list-group-item-dark h5,
.sessoesSubabaTabela .list-group-item-dark h6 {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
}

.sessoesPainelConteudo .sessoesSubabaLinha {
  background: #ffffff;
  min-height: 54px;
  padding: 11px 16px;
  transition: background 0.15s ease;
}

.sessoesPainelConteudo .sessoesSubabaLinha:hover {
  background: #f7f9f8;
}

.sessoesSubabaLinha h5 {
  color: #30373c;
  font-weight: 600;
}

.sessoesSubabaLinha h6,
.sessoesSubabaLinha small {
  color: #778188;
}

.sessoesSubabaLinha .btn-danger {
  background: #ffffff;
  border-color: #d79a9a;
  color: #a94747;
  font-size: 10px;
  height: 28px;
  margin: 0 !important;
  padding: 0 9px;
  zoom: 1 !important;
}

.sessoesSubabaLinha .btn-danger:hover {
  background: #a94747;
  border-color: #a94747;
  color: #ffffff;
}

.sessoesSubabaVazio {
  align-items: center;
  color: #7f8990;
  display: flex;
  flex-direction: column;
  font-size: 11px;
  gap: 8px;
  justify-content: center;
  min-height: 150px;
  padding: 18px;
  text-align: center;
}

.sessoesSubabaVazio i {
  font-size: 20px;
}

.sessoesPainelConteudo > div > .row {
  margin-left: 0;
  margin-right: 0;
}

.sessoesPainelConteudo .col-md-10.offset-md-1 {
  flex: 0 0 100%;
  margin-left: 0;
  max-width: 100%;
}

.sessoesPainelConteudo .d-flex.justify-content-between,
.sessoesPainelConteudo .d-flex.justify-content-start,
.sessoesPainelConteudo .d-flex.justify-content-center {
  align-items: center;
  background: #f6f7f8;
  border: 1px solid #dfe3e7;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-start !important;
  padding: 10px;
}

.sessoesPainelConteudo .d-flex > .form-control,
.sessoesPainelConteudo .d-flex > select {
  font-size: 11px;
  height: 34px;
  margin-right: 0 !important;
  max-width: 280px;
}

.sessoesPainelConteudo .d-flex > .btn {
  height: 32px;
  margin: 0;
}

.sessoesPainelConteudo hr {
  border-color: #e0e4e7;
  margin: 12px 0;
}

.sessoesPainelConteudo .rowLista {
  border: 1px solid #dfe3e7;
  border-radius: 4px;
  margin-bottom: 15px;
  overflow: hidden;
}

.sessoesPainelConteudo .list-group-item {
  border: 0;
  border-bottom: 1px solid #e4e7ea;
  padding: 8px 12px;
}

.sessoesPainelConteudo .list-group-item:last-child {
  border-bottom: 0;
}

.sessoesPainelConteudo .list-group-item-dark {
  background: #333a40;
  color: #ffffff;
}

.sessoesPainelConteudo .list-group-item-action:hover {
  background: #f5f8f6;
}

.sessoesPainelConteudo .list-group-item h5,
.sessoesPainelConteudo .list-group-item h6 {
  font-size: 12px;
  line-height: 1.35;
  margin-bottom: 0;
  margin-top: 0 !important;
}

.sessoesPainelConteudo .list-group-item h6 {
  font-size: 10px;
}

@media (max-width: 1100px) {
  .sessoesMetricas {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sessoesVisaoGeral {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .sessoesPainel {
    padding-left: 8px;
    padding-right: 8px;
  }

  .sessoesCabecalho {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }

  .sessoesCabecalhoAcoes {
    align-items: flex-end;
  }

  .sessoesFiltroSite {
    flex: 1;
    width: auto;
  }

  .sessoesMetricas {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sessoesMetrica {
    min-height: 66px;
    padding: 9px;
  }

  .sessoesMetricaIcone {
    flex-basis: 32px;
    height: 32px;
  }

  .sessoesMetrica div strong {
    font-size: 18px;
  }

  .sessoesRankingItem {
    gap: 8px;
    grid-template-columns: minmax(0, 1fr) 40px 8px;
  }

  .sessoesRankingBarra {
    display: none;
  }

  .sessoesPainelConteudo .d-flex > .form-control,
  .sessoesPainelConteudo .d-flex > select {
    max-width: none !important;
    width: 100%;
  }

  .sessoesSubabaCabecalho {
    padding-left: 12px;
    padding-right: 12px;
  }

  .sessoesPainelConteudo .sessoesSubabaFiltros {
    padding: 10px 12px;
  }

  .sessoesPainelConteudo .sessoesSubabaTabela .list-group-item-dark,
  .sessoesPainelConteudo .sessoesSubabaLinha {
    padding-left: 10px;
    padding-right: 10px;
  }

  .sessoesSubabaTabela .row {
    flex-wrap: nowrap;
  }

  .sessoesSubabaTabela .col-md-3 {
    flex: 0 0 86px;
    max-width: 86px;
  }

  .sessoesSubabaTabela .list-group-item-dark h5,
  .sessoesSubabaTabela .list-group-item-dark h6 {
    font-size: 8px;
    white-space: nowrap;
  }
}
</style>
